import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrefijoPaisesService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description recuperar los prefijos de los paises
   */
  getPrefix(): Observable<any> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
        // .append('x-api-key' , '7d1b61478a3911ef8cd3cd24a31e207c') // DEV
        .append('x-api-key' , '4514e03e7fec11ef8cd36b41513bc039') // TEST
    };

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.prefijoPaises.name,
      headerConfig
    ).pipe(
      map((e: any) => {
        const prefixList: any[] = e;
        return prefixList.map(prefijo => ({ id: prefijo.idPrefijo, name: prefijo.prefijos }));
      })
    );
  }
}
